import React from 'react'
import {Link, useLocation, useParams} from 'react-router-dom'
import {DelaisTraitementForm} from './components/DelaisTraitementForm'
import {ModeleDelaisTraitement} from '../../../components/Models'

type LocationState = {
  data: ModeleDelaisTraitement | undefined | null
}

const DelaisTraitementPage = () => {
  let {delaisTraitementId} = useParams()
  const location = useLocation()
  const state = location.state as LocationState


  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>{(delaisTraitementId === undefined) ? 'Créer' : 'Modifier'} un délai de traitement</h3>
          </div>
        </div>

        <div>
          <DelaisTraitementForm id={delaisTraitementId} data={state ? state.data : null}/>
        </div>
      </div>
    </>
  )
}

export {DelaisTraitementPage}
